// Main exports
export { IncentivWrapper } from './core/IncentivWrapper';

// Re-export official SDK components for convenience
export {
  IncentivSigner,
  IncentivResolver,
  IncentivEnvironment
} from '@incentiv/dapp-sdk';

// Types
export * from './types';

// Utils
export * from './utils';

// Version
export const VERSION = '1.0.0';

// Browser compatibility
declare global {
  interface Window {
    IncentivWrapper?: any;
  }
}

if (typeof window !== 'undefined') {
  // Import for browser global
  import('./core/IncentivWrapper').then(({ IncentivWrapper }) => {
    window.IncentivWrapper = IncentivWrapper;
  });
}
